import GenericGridCreator from 'ps-components/AdvancedTable/GenericGrid/GenericGridCreator';
import { GenericSurveyDetails } from 'ps-components/AdvancedTable/GenericGrid/GenericGridCellRenderers';

const newGenericGrid = new GenericGridCreator(
  'MARKETPLACE_MATCHES',
  {},
  {
    defaultLeftColumns: [
      {
        Header: 'Survey Job Matches',
        stickyLeft: true,
        customRender: GenericSurveyDetails,
        width: 400,
        accessor: null
      }
    ],
    hiddenTerms: [
      'field_survey_code',
      'field_job_code',
      'field_job_scope',
      'field_pub_survey_long_name',
      'field_cutId',
      'field_pubSurveyCode',
      'field_jobCode',
      'field_jobTitle',
      'field_surveyTitle',
      'field_surveyIndustry',
      'field_surveyGeography',
      'field_companyCount',
      'field_employeeCount',
      'field_effectiveDate',
      'field_confidence',
      'field_active',
      'field_purchased',
      'field_description',
      'field_surveyCurrency',
      'field_surveyCode',
      'field_surveyJobCode',
      'field_surveyJobTitle',
      'field_pubSurveyEffectiveDate',
      'field_recommendationsId',
      'field_pubSurveyTitle',
      'field_availableForPurchase',
      'field_purchasePrice',
      'field_participationPurchasePrice',
      'field_contractLanguageURL',
      'field_pubSurveyPublisher'
    ],
    tableProps: {
      onRowClick: null,
      useSelectAll: false
    }
  },
  {
    getInstanceState: store => store.marketplaceMatches.marketplaceMatchesGridReducer
  }
);
export const marketplaceMatchesGridActions = newGenericGrid.getActions();
// TODO: figure out why onSortChange's reducer is called on every render
marketplaceMatchesGridActions.onSortChange = null;

export default newGenericGrid.createReducer();
